export function seo({
  title,
  description
}: { title: string; description?: string }) {
  return [
    { title: `${title} | myTalquin Member Portal` },
    { name: description, content: description }
  ];
}
